<template>
<div class="charge-groups">
  <div class="form-group">
    <label>Fiscal year</label>
    <select class="form-control w-25" v-model="selectedYear">
      <option v-for="year in years" :key="year" :value="year">
        {{ year }}
      </option>
    </select>
  </div>
  <b-table
    :sticky-header="'stickyHeader'"
    no-border-collapse
    striped
    hover
    fixed
    Outlined
    show-empty
    :empty-text="'No data available'"
    :items="groups"
    :fields="hasAuth(['senior']) ? fields : fields.slice(0, 4)"
    :table-class="'list-table text-center'"
    :thead-class="'list-table__head'"
    :tbody-class="'list-table__body'"
  >
    <template #cell(Detail)="group">
      <b-button pill variant="outline-secondary" size="sm"
        class="w-100"
        :disabled="!group.item.lessonId"
        :to="{
          name: 'ClassRecordEdit',
          params: {
            lessonId: group.item.lessonId,
          },
        }"
      >
        Detail
      </b-button>
    </template>
  </b-table>
</div>
</template>

<script lang="ts">
import {
  Component,
  Prop,
  Vue,
  Watch,
} from 'vue-property-decorator'
import _ from 'lodash'
import moment from 'moment'
import { Group, Tutor } from '@/store/tutors/types'
import { weekdayKey, Weekdays } from '@/store/common.types'
import { Semester } from '@/store/master/types'
import { RootState } from '@/store/types'

@Component
export default class TutorProfileChargeGroups extends Vue {
  @Prop({ required: true }) tutor!: Tutor

  private selectedYear: number = moment().year()

  private years: number[] = (() => {
    const startYear = 2020
    const endYear = moment().year() + 1
    return _.range(startYear, endYear + 1)
  })()

  private fields = [
    {
      key: 'course',
      label: 'Course',
      formatter: (c: { name: string }) => c.name,
    },
    {
      key: 'semester',
      label: 'Semester',
      formatter: (s: Semester) => s.name,
    },
    {
      key: 'weekday',
      label: 'Day of Week',
      formatter: (key: weekdayKey) => Weekdays[key],
    },
    {
      key: 'period',
      label: 'Period',
    },
    {
      key: 'Detail',
    },
  ]

  private get groups(): Group[] {
    return this.tutor.groups
  }

  private created() {
    this.fetchGroups()
  }

  private fetchGroups() {
    this.$store.dispatch('fetchTutorGroups', {
      tutorId: this.tutor.id,
      fiscalYear: this.selectedYear,
    })
  }

  private hasAuth(acceptRoles: string[]): boolean {
    const auth = (this.$store.state as RootState).auth.profile?.authority
    return _.indexOf(acceptRoles, auth) !== -1
  }

  @Watch('selectedYear')
  private changedYear() {
    this.fetchGroups()
  }
}
</script>

<style scoped>
.btn {
  min-width: initial;
}
</style>

<style>
.charge-groups .list-table__head {
  font-size: .8rem;
}
</style>
